import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

export default function LegalPage({ title, children }) {
  return (
    <div className="legal-page">
      <nav className="legal-nav">
        <Link to="/" className="legal-nav-logo">Lotto<span>Pickle</span></Link>
        <Link to="/" className="legal-nav-back">&larr; Back to home</Link>
      </nav>

      <div className="legal-content">
        <h1>{title}</h1>
        <p className="legal-effective">Effective date: April 2, 2026</p>
        {children}
      </div>

      <footer className="legal-footer">
        <ul className="legal-footer-links">
          <li><Link to="/terms">Terms</Link></li>
          <li><Link to="/privacy">Privacy</Link></li>
          <li><Link to="/eula">EULA</Link></li>
          <li><Link to="/">Home</Link></li>
        </ul>
      </footer>
    </div>
  );
}
